const categories = [
  { label: '国产剧', icon: 'ri-tv-line', count: '2800+', color: 'bg-primary-100 text-primary-600' },
  { label: '港台剧', icon: 'ri-vidicon-line', count: '1200+', color: 'bg-accent-100 text-accent-600' },
  { label: '日韩剧', icon: 'ri-earth-line', count: '950+', color: 'bg-secondary-100 text-secondary-700' },
  { label: '欧美剧', icon: 'ri-global-line', count: '1500+', color: 'bg-primary-100 text-primary-600' },
  { label: '综艺', icon: 'ri-mic-line', count: '2100+', color: 'bg-accent-100 text-accent-600' },
  { label: '动漫', icon: 'ri-emotion-line', count: '1800+', color: 'bg-secondary-100 text-secondary-700' },
  { label: '纪录片', icon: 'ri-camera-line', count: '650+', color: 'bg-primary-100 text-primary-600' },
  { label: '电影', icon: 'ri-film-line', count: '3200+', color: 'bg-accent-100 text-accent-600' },
  { label: '短剧', icon: 'ri-flashlight-line', count: '500+', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-layout-grid-line"></i>
            分类浏览
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            剧集索引
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型快速找到你想看的剧集</p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-9 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.label}
              href="#index"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200/70 border border-background-200/60 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${cat.color} transition-transform group-hover:scale-110`}>
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-sm font-bold text-foreground-900 whitespace-nowrap">{cat.label}</span>
              <span className="text-[10px] md:text-xs text-foreground-400">{cat.count}部</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}